module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/p-gma-300.c99c2fa357b4335b.png"+" 300w",
        images: [{path: "https://static.sniffspot.com/packs/img/p-gma-300.c99c2fa357b4335b.png",width: 300,height: 141}],
        src: "https://static.sniffspot.com/packs/img/p-gma-300.c99c2fa357b4335b.png",
        toString: function(){return "https://static.sniffspot.com/packs/img/p-gma-300.c99c2fa357b4335b.png"},
        
        width: 300,
        height: 141
      }